import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Checkbox from "@mui/material/Checkbox";
import DataTable from "examples/Tables/DataTable";

function SchemaDataTable({
  data,
  columnsSchema,
  getRowId,
  selectable,
  selectedIds,
  onToggle,
  tableProps,
}) {
  const columns = useMemo(() => {
    const cols = columnsSchema.map((c) => ({
      Header: c.header,
      accessor: c.accessor,
      align: c.align || "left",
      width: c.width,
    }));

    if (!selectable) return cols;

    return [{ Header: "", accessor: "__checkbox", align: "center", width: "2%" }, ...cols];
  }, [columnsSchema, selectable]);

  const rows = useMemo(() => {
    return data.map((row) => {
      const id = getRowId(row);

      const built = {};
      // optional checkbox column
      if (selectable) {
        built.__checkbox = (
          <Checkbox size="small" checked={selectedIds.includes(id)} onChange={() => onToggle(id)} />
        );
      }

      // normal columns
      columnsSchema.forEach((c) => {
        if (typeof c.render === "function") {
          built[c.accessor] = c.render(row);
        } else {
          // default display if no render is provided
          built[c.accessor] = row?.[c.accessor];
        }
      });

      return built;
    });
  }, [data, columnsSchema, selectable, selectedIds, onToggle, getRowId]);

  return (
    <DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={false}
      showTotalEntries={false}
      noEndBorder
      canSearch={false}
      size="small"
      {...(tableProps || {})}
    />
  );
}

SchemaDataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columnsSchema: PropTypes.array.isRequired,
  getRowId: PropTypes.func,
  selectable: PropTypes.bool,
  selectedIds: PropTypes.array,
  onToggle: PropTypes.func,
  tableProps: PropTypes.object,
};

SchemaDataTable.defaultProps = {
  getRowId: (row) => row.id,
  selectable: false,
  selectedIds: [],
  onToggle: () => {},
  tableProps: {},
};

export default SchemaDataTable;
